import Vue from 'vue';
import MaeElenialsWrapper from '@/wrappers/MaeElenials';

Vue.component('mae-elenials-wrapper', MaeElenialsWrapper);
